(() => {
  const init = (root) => {
    if (!root || root.dataset.hvlReady === 'true') return;
    root.dataset.hvlReady = 'true';

    root.querySelectorAll('[data-hvl-control]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.hvlControl;
        root.querySelectorAll('[data-hvl-control]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        root.querySelectorAll('[data-hvl-control-image]').forEach((image) => {
          image.hidden = image.dataset.hvlControlImage !== id;
        });
      });
    });

    root.querySelectorAll('[data-hvl-app-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.hvlAppTab;
        root.querySelectorAll('[data-hvl-app-tab]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        root.querySelectorAll('[data-hvl-app-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.hvlAppPanel !== id;
          panel.classList.toggle('is-active', panel.dataset.hvlAppPanel === id);
        });
      });
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-hvl-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
